import { render, staticRenderFns } from "./side-menu-element.vue?vue&type=template&id=638fa0e8"
import script from "./side-menu-element.vue?vue&type=script&lang=js"
export * from "./side-menu-element.vue?vue&type=script&lang=js"
import style0 from "./side-menu-element.vue?vue&type=style&index=0&id=638fa0e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports